import { useEffect, useState } from "react";
import { loading } from "@/lib/loading";
import { Loader2 } from "lucide-react";

/**
 * GlobalLoader
 * Renders a thin top progress bar whenever any /api request is in-flight,
 * plus a small floating "Loading" pill in the bottom-right corner for clarity.
 */
export default function GlobalLoader() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const unsub = loading.subscribe(setCount);
    return () => unsub();
  }, []);

  const active = count > 0;

  return (
    <>
      {/* Top progress bar */}
      <div
        aria-hidden
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: active ? "linear-gradient(90deg, #4d7c0f, #84cc16, #4d7c0f)" : "transparent",
          backgroundSize: "200% 100%",
          animation: active ? "ams-loading-shimmer 1.2s linear infinite" : "none",
          transition: "opacity 200ms ease",
          opacity: active ? 1 : 0,
          zIndex: 9999,
          pointerEvents: "none",
        }}
        data-testid="global-loading-bar"
      />

      {/* Bottom-right pill (unobtrusive, only shows on longer waits) */}
      {active && (
        <div
          data-testid="global-loading-pill"
          className="fixed bottom-4 right-4 z-[9998] flex items-center gap-2 rounded-full bg-slate-900 text-white text-xs font-medium px-3 py-2 shadow-lg animate-in fade-in"
          role="status"
          aria-live="polite"
        >
          <Loader2 size={14} className="animate-spin text-lime-400" />
          <span>Loading…</span>
        </div>
      )}

      <style>{`
        @keyframes ams-loading-shimmer {
          0%   { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
      `}</style>
    </>
  );
}
